import React from 'react';
import { formatDate, getFieldName } from '../../utils/constants';
import { styles } from './styles';

function HistoryTab({ history }) {
  if (history.length === 0) {
    return (
      <div style={styles.fadeIn}>
        <div style={styles.formSection}>
          <h4 style={styles.sectionTitle}>수정 이력</h4>
          <div style={styles.emptyState}>
            <span style={styles.emptyIcon}>📜</span>
            <p>수정 이력이 없습니다</p>
          </div>
        </div>
      </div>
    );
  }

  // 이력 그룹화
  const grouped = {};
  history.forEach(item => {
    const key = `${item.changed_at}_${item.user_id || 'unknown'}`;
    if (!grouped[key]) {
      grouped[key] = {
        changed_at: item.changed_at,
        username: item.username,
        items: []
      };
    }
    grouped[key].items.push(item);
  });

  return (
    <div style={styles.fadeIn}>
      <div style={styles.formSection}>
        <h4 style={styles.sectionTitle}>수정 이력</h4>
        <div style={styles.historyList}>
          {Object.values(grouped).map((group, index) => (
            <div key={index} style={styles.historyItem}>
              <div style={styles.historyHeader}>
                <div style={styles.historyTime}>
                  {formatDate(group.changed_at)} {new Date(group.changed_at).toLocaleTimeString('ko-KR')}
                </div>
                <div style={styles.historyUser}>
                  수정자: {group.username || '알 수 없음'}
                </div>
              </div>
              {group.items.map((item, idx) => (
                <div key={idx} style={styles.historyChange}>
                  <div style={styles.historyField}>
                    {getFieldName(item.field_name)}
                  </div>
                  <div style={styles.historyValues}>
                    <span style={styles.oldValue}>
                      {item.old_value || '(없음)'}
                    </span>
                    <span style={styles.arrow}>→</span>
                    <span style={styles.newValue}>
                      {item.new_value || '(없음)'}
                    </span>
                  </div>
                </div>
              ))}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default HistoryTab;
